module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.isDownloading) ? _c('div', {
    staticClass: "downloading-bar"
  }, [_c('div', {
    staticClass: "download-content"
  }, [_c('el-progress', {
    staticClass: "download-progress",
    attrs: {
      "customClass": "download-progress",
      "width": 40,
      "type": "circle",
      "percentage": _vm.getDownloading.progress
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "download-title"
  }, [_vm._v(_vm._s((_vm.getDownloading.preparing) ? _vm.$l('main/preparingFile') : _vm.$l('main/downloadingFile')) + " ")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header",
    class: _vm.isDownloading ? 'header-downloading' : ''
  }, [_c('div', {
    staticClass: "menu-icon",
    attrs: {
      "title": _vm.$l('calendar/title')
    },
    on: {
      "click": _vm.menuOnClick
    }
  }, [_c('i', {
    staticClass: "el-icon-menu"
  })]), _vm._v(" "), _c('div', {
    staticClass: "header-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "download-button",
    attrs: {
      "title": _vm.$l('main/titleStatistics')
    },
    on: {
      "click": function($event) {
        return _vm.onStatisticsClick()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "line-chart"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "download-button",
    attrs: {
      "title": _vm.$l('main/titleManual')
    },
    on: {
      "click": function($event) {
        return _vm.goToManual()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "question"
    }
  })], 1), _vm._v(" "), _c('el-popover', {
    ref: "download-button-popover",
    attrs: {
      "placement": "bottom",
      "width": "150",
      "trigger": "click"
    }
  }, [_c('download-popover')], 1), _vm._v(" "), (_vm.$p('download')) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDownloads),
      expression: "showDownloads"
    }, {
      name: "popover",
      rawName: "v-popover:download-button-popover",
      arg: "download-button-popover"
    }],
    staticClass: "download-button",
    attrs: {
      "title": _vm.$l('main/titleDownload')
    }
  }, [_c('icon', {
    attrs: {
      "name": "download"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-popover', {
    ref: "archives-button-popover",
    attrs: {
      "placement": "bottom",
      "width": "150",
      "trigger": "click"
    }
  }, [_c('archive-popover')], 1), _vm._v(" "), (_vm.$p('archives')) ? _c('div', {
    directives: [{
      name: "popover",
      rawName: "v-popover:archives-button-popover",
      arg: "archives-button-popover"
    }],
    staticClass: "archives-button el-icon-document",
    class: {
      'menu-icon-enabled': _vm.isArchives
    },
    attrs: {
      "title": _vm.$l('main/titleArchives')
    }
  }) : _vm._e(), _vm._v(" "), _c('el-popover', {
    ref: "stream-button-popover",
    attrs: {
      "placement": "bottom",
      "width": "300",
      "trigger": "click"
    }
  }, [_c('stream-popover')], 1), _vm._v(" "), (_vm.$p('streamPopover/enabled')) ? _c('div', {
    directives: [{
      name: "popover",
      rawName: "v-popover:stream-button-popover",
      arg: "stream-button-popover"
    }],
    staticClass: "stream-button",
    attrs: {
      "title": _vm.$l('main/titleStream')
    }
  }, [_c('icon', {
    attrs: {
      "name": "volume-up"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-popover', {
    ref: "play-button-popover",
    attrs: {
      "placement": "bottom",
      "width": "150",
      "trigger": "click"
    }
  }, [_c('play-popover')], 1), _vm._v(" "), (_vm.$p('realtime')) ? _c('div', {
    staticClass: "realtime-button el-icon-time",
    class: {
      'realtime-enabled': _vm.getRealtimeEnabled
    },
    attrs: {
      "title": _vm.$l('main/titleRealtime')
    },
    on: {
      "click": _vm.toggleRealtime
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$p('measurement/enabled')) ? _c('div', {
    directives: [{
      name: "popover",
      rawName: "v-popover:play-button-popover",
      arg: "play-button-popover"
    }],
    staticClass: "play-button",
    class: _vm.playButtonClass,
    attrs: {
      "title": (_vm.playButtonClass.danger) ? _vm.$l('main/titleDanger') : ((_vm.playButtonClass.warning) ? _vm.$l('main/titleWarning') : _vm.$l('main/titlePlay'))
    }
  }, [_c('div', {
    staticClass: "play-button-inside"
  })]) : _vm._e(), _vm._v(" "), (_vm.$p('settings/enabled')) ? _c('div', {
    staticClass: "settings-button el-icon-setting",
    class: {
      'menu-icon-enabled': _vm.isSettings
    },
    attrs: {
      "title": _vm.$l('main/titleSettings')
    },
    on: {
      "click": function($event) {
        return _vm.navigateToSettings()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "logout-button",
    attrs: {
      "title": _vm.$l('main/titleLogout')
    },
    on: {
      "click": function($event) {
        return _vm.logoutClicked()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "sign-out"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "main",
    class: _vm.isDownloading ? 'main-downloading' : ''
  }, [_c('calendar-container', {
    attrs: {
      "screenSize": _vm.screenSize,
      "sidebarVisible": _vm.sidebarVisible
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.contentClassname
  }, [(_vm.statusMessage) ? _c('div', {
    staticClass: "top-error-message"
  }, [_vm._v(_vm._s(_vm.$l('errors/' + _vm.statusMessage.split(":")[0]) + (_vm.statusMessage.indexOf(':') > -1 ? (": " + _vm.$l('codes/' + _vm.statusMessage.split(":")[1])) : '')))]) : _vm._e(), _vm._v(" "), (_vm.sdStatusMessage) ? _c('div', {
    staticClass: "top-error-message"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.$l('main/titleSD'))), _c('span', [_vm._v(" " + _vm._s(_vm.roundDecimal) + "% ")]), _vm._v(" (" + _vm._s(_vm.$l('settings/status/of')) + " 2 Gb)")]) : _vm._e(), _vm._v(" "), (_vm.hddStatusMessage) ? _c('div', {
    staticClass: "top-error-message"
  }, [_vm._v(_vm._s(_vm.$l('main/titleHDD'))), _c('span', [_vm._v(" " + _vm._s(_vm.roundDecimalHDD) + "% ")])]) : _vm._e(), _vm._v(" "), _c('router-view')], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b7e7782c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/Main.vue
// module id = 478
// module chunks = 1